import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.navsartstudio.com';
const DEFAULT_OG_IMAGE =
  'https://customer-assets.emergentagent.com/job_navs-art-studio/artifacts/j2uwmz8f_68BB0444-5D6B-4E65-94A6-BFF19BB84356.JPG';
const SITE_NAME = 'Navs Art Studio';

export const SEO = ({
  title,
  description,
  path = '',
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  jsonLd,
  noIndex = false,
  metaTitle,
}) => {
  const url = `${SITE_URL}${path}`;
  const composedTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Handcrafted Resin Artwork`;
  const fullTitle = metaTitle || composedTitle;
  const desc =
    description ||
    'Handcrafted, one-of-a-kind resin and textured artwork by Navs Art Studio — ocean-inspired pieces, automotive wall art, coasters, and custom commissions.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={title || SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default SEO;
